
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from '@env/environment';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {

        if (environment.log.missingTranslations === true) {
            console.log(`missing translation: '${params.key}'`);
        }
    }
}
